(() => {
  const hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');

  const initializeMenus = (root = document) => {
    root.querySelectorAll('.wps-header-nav header-menu').forEach((menu) => {
      if (menu.dataset.wpsMenuReady === 'true') return;

      const details = menu.querySelector(':scope > details');
      const summary = details?.querySelector(':scope > summary');
      if (!details || !summary) return;

      let closeTimer;
      let openedByHover = false;
      const close = (restoreFocus = false) => {
        window.clearTimeout(closeTimer);
        details.open = false;
        openedByHover = false;
        summary.setAttribute('aria-expanded', 'false');
        if (restoreFocus) summary.focus();
      };

      const closeOtherMenus = () => {
        document.querySelectorAll('.wps-header-nav header-menu > details[open]').forEach((openMenu) => {
          if (openMenu !== details) {
            openMenu.open = false;
            openMenu.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
          }
        });
      };

      details.addEventListener('toggle', () => {
        summary.setAttribute('aria-expanded', String(details.open));
        if (details.open) closeOtherMenus();
      });

      menu.addEventListener('pointerenter', () => {
        if (!hoverQuery.matches) return;
        window.clearTimeout(closeTimer);
        closeOtherMenus();
        if (!details.open) {
          details.open = true;
          openedByHover = true;
        }
      });

      summary.addEventListener('click', (event) => {
        if (!openedByHover || !details.open) return;
        event.preventDefault();
        openedByHover = false;
      });

      menu.addEventListener('pointerleave', () => {
        if (!hoverQuery.matches) return;
        closeTimer = window.setTimeout(close, 120);
      });

      menu.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || !details.open) return;
        event.preventDefault();
        close(true);
      });

      summary.setAttribute('aria-expanded', String(details.open));
      menu.dataset.wpsMenuReady = 'true';
    });
  };

  initializeMenus();
  document.addEventListener('shopify:section:load', (event) => initializeMenus(event.target));
})();
